import Swiper from 'swiper';

export default class Slider {
  constructor(rootNode) {
    const options = {
      slidesPerView: 'auto',
      speed: 300,
      loop: false,
      spaceBetween: 30,
      loadPrevNext: true,
      loadOnTransitionStart: true,
      watchSlidesVisibility: true,
      pagination: {
        el: rootNode.querySelector('.swiper-pagination'),
        clickable: true,
      },
      preloadImages: false,
      lazy: true,
    };

    new Swiper(rootNode, options);
  }
}
